import React,{useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css'

export default function About() {
    useEffect(() => {
        AOS.init({
          duration : 2000
        });
      }, []);
    return (
        <div className='about'>
            <div data-aos="fade-up" class="section-header">
                 <h1 class="section-heading">ABOUT US</h1>
                <div class="underline"></div>

            </div>
            <div data-aos="fade-up"  className='another'>
                <h1>What We Do</h1>
                    <p>
                           <b>TO-FRO-DOTCOM NIGERIA LIMITED</b>  is a full service logistics company incorporated in 2015 with the vision to provide a one stop solution of all logistics and transport related services in an efficient and timeless manner.
                        From haulage services which we are most foremost for, to relocation services, car rentals, fleet management for corperate bodies and school bus service, we strive to ensure that we exceed our customers’ expectations by offering bespoke services as may be required. Our dedicated teams of young and talented professionals are always on ground to ensure world class service at all times.
                        Since inception we have grown from 2 to 6 trucks, 7 salon cars and 4 Toyota busses all owned and managed by us with ongoing plans to acquire more as the need arises. All our vehicles are well equipped with GPS tracking system, comprehensive insurance and maintained to the highest safety standards.
                    </p>
                    <p>
                    <b>At TO-FRO-DOTCOM NIGERIA LIMITED</b> , we are passionate about operating to the highest possible standards and
                    we are committed to exceeding our customers’ expectations. We have established a reputation of trust and goodwill
                    among our few prestigious
                    clients and aspire to become a market leader in the Logistics industry.
                    </p>
                <h1>CORPERATE PROFILE</h1>
                    <p class='up'><b>Company Name:</b>  TO-FRO-DOTCOM NIGERIA LIMITED</p>
                    <p class='up'><b>Head Office Address:</b>  18A Kafayat Abdulrasaq street. Off Fola Osibo. Lekki Phase 1 Lagos Nigeria</p>
                    <p class='up'><b> Contact email address:</b> tofrodotcom@gmail.com</p>
                <h1>WHAT OUR SERVICE COVERS</h1>
                    <ul>
                        <li>Driver sourcing, training and management </li>
                        <li>Fueling and fuel management </li>
                        <li>Maintenance alerts and reminders </li>
                        <li>Servicing, proactive and corrective maintenance </li>
                        <li>Vehicle Tracking and monitoring </li>
                        <li>Response time management  </li>
                        <li>Accident management </li>
                    </ul>
                <h1>OUR PROMISE TO YOU </h1>
                <ul>
                    <li>Provide vehicles that are safe, reliable and environmentally sound at competitive prices/ rates </li>
                    <li>Provide honest, responsive, effective and efficient service to our client at all times</li>
                    <li>Transparency and accountability in all our transactions with you </li>
                    <li>Round the clock telematics</li>
                </ul>
                <h1>CONCLUSION</h1>
                <p class='down'> <b>TO-FRO-DOTCOM </b> 
                 is confident that our service to you will improve your services and business operations.
                We sincerely hope that you will consider us a long term partner and allow us to enter into a mutually beneficial business relationship.
                We are available to answer
                any questions or concerns you may have regarding our company and look forward to discussing this opportunity further.
                </p>
            </div>
            
        </div>
    )
}
